import styled from 'styled-components'
import { colors } from '../../../constants'

const Wrapper = styled.div`
    background: #0004;
    position: fixed;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
    

    ${({ confirm }) => (confirm ? `z-index: 6000;` : `z-index: 5000;`)}
`

const Frame = styled.div`
    background: white;
    border-radius: 0px;
    box-shadow: 1px 1px 4px 2px #0003;
    ${({ scrollable }) => scrollable && `overflow: auto;`}
    padding: 0px;
    position: fixed;
    transition: all 0.3s;
    left: 50%;
    top: 50%;
    text-align: left;
    overflow-y: scroll;
    & textarea {
        font-size: 13px;
    }

    ${({ width }) => width && `width: ${width};`}

  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}

  max-height: 85vh;
    max-width: 90%;

    ${({ confirm }) => (confirm ? `z-index: 3;` : `z-index: 2;`)}

    ${({ open }) => (open ? `transform: translate(-50%, -50%) scale(1, 1);` : `transform: translate(-50%, 100%) scale(0, 0);`)}
`

const Background = styled.div`
    height: 100%;
    z-index: 2;
`

const CloseButton = styled.button`
    background: ${colors.white};
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.greylight};
    outline: none;
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
    z-index: 3;
    border: none;
    padding: 0;
`

export { Background, CloseButton, Frame, Wrapper }
